import * as React from 'react';
import * as styles from './index.css';

export const PartnerBadge = () => <div className={styles['partner_badge']}>Партнёр</div>;
